import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "space-y-2.5" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "space-y-2.5 mt-4" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "inset-y-0 right-0 flex items-center px-4 bg-gray-200 border-r border-gray-400 rounded-r border-y" }
const _hoisted_20 = { class: "uppercase" }
const _hoisted_21 = { class: "space-y-2.5 mt-4" }
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "flex space-x-4" }
const _hoisted_24 = { class: "block space-x-2" }
const _hoisted_25 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_26 = { class: "block space-x-2" }
const _hoisted_27 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_28 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { useGlobalStore } from "@/store";
import { CountryPrice } from "@/types";
import { storeToRefs } from "pinia";
import { ref, PropType, onMounted } from "vue";
import DefaultButton from "../DefaultButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCountryPriceModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  existingCountryPrice: {
    type: Object as PropType<CountryPrice>,
    required: false,
  },
},
  emits: ["close", "select"],
  setup(__props, { emit: emits }) {

const props = __props;



const { countries } = storeToRefs(useGlobalStore());

const selectedCountry = ref(countries.value[0]);
const countryprice = ref({} as CountryPrice);

function close() {
  emits("close");
}

function setSelectedCountry(e: any) {
  selectedCountry.value = countries.value.find(i => i.id == e.target.value);
  countryprice.value.country = selectedCountry.value.name;
  countryprice.value.currency = selectedCountry.value.currency;
}

function AddCountryPrice() {
  emits("select", {
    country: countryprice.value.country,
    pricing: countryprice.value.pricing * 100,
    vat: countryprice.value.vat,
    currency: countryprice.value.currency,
  });
}

onMounted(() => {
  if (props.existingCountryPrice) {
    countryprice.value = props.existingCountryPrice;
  }
});

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("country-and-price")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 mt-4 border-b border-gray-400",
                  onSubmit: AddCountryPrice
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("country")), 1),
                    _createElementVNode("select", {
                      id: "country",
                      class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                      required: "",
                      onChange: setSelectedCountry
                    }, [
                      _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("please-select")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: country.id,
                          class: "capitalize",
                          value: country.id
                        }, _toDisplayString(country.name), 9, _hoisted_15))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("price")), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "0",
                        step: "0.01",
                        name: "price",
                        id: "price",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryprice.value.pricing) = $event)),
                        class: "capitalize text-black border w-full rounded-l focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                        placeholder: "0.00",
                        required: ""
                      }, null, 512), [
                        [_vModelText, countryprice.value.pricing]
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(selectedCountry.value.currency), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("excluding-vat")), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "vat",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((countryprice.value.vat) = $event)),
                          value: false,
                          class: "rounded-full hover:cursor-pointer",
                          required: ""
                        }, null, 512), [
                          [_vModelRadio, countryprice.value.vat]
                        ]),
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("yes")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "vat",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((countryprice.value.vat) = $event)),
                          value: true,
                          class: "rounded-full hover:cursor-pointer",
                          required: ""
                        }, null, 512), [
                          [_vModelRadio, countryprice.value.vat]
                        ]),
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("no")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})